export default __webpack_public_path__ + "static/product-management-hero@2x-539d9be6ef785666a93b454caa223df2.png";